import { useState } from 'react';
import { useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { StudentBookingErrorResponse } from 'src/api/types';

import { getUserExists, UserEndpoints } from '../../api/user';

export const useGetUserExists = (
    config?: UseQueryOptions<boolean, AxiosError<StudentBookingErrorResponse>>
) => {
    const [email, setEmail] = useState<string>('');
    const queryClient = useQueryClient();

    const query = useQuery<boolean, AxiosError<StudentBookingErrorResponse>>({
        ...config,
        enabled: !!email,
        queryKey: [UserEndpoints.getUserExists],
        queryFn: () => getUserExists(email),
    });

    const fetchByEmail = (value: string) => {
        setEmail(value);
    };

    const clearCache = () => {
        setEmail('');
        queryClient.removeQueries({ queryKey: [UserEndpoints.getUserExists], exact: true });
    };

    return {
        ...query,
        fetchByEmail,
        clearCache,
    };
};
